// extracted by mini-css-extract-plugin
export default {"root__title":"style-module__root__title___zTmd7","root__list":"style-module__root__list___smjpj","root__list_text":"style-module__root__list_text___ykP1O","root__list_item":"style-module__root__list_item___HsPb5","root__list_btn":"style-module__root__list_btn___FYtOg"};
    if(module.hot) {
      // 1729151133943
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  